import { graphql } from 'relay-runtime';

export const getStudentTableFiltersInfo = graphql`
  query StudentsDataTableFiltersQuery(
    $skip: Boolean = false
    $first: Int
    $after: String
    $last: Int
    $before: String
  ) {
    classes(first: $first, after: $after, last: $last, before: $before) @skip(if: $skip) {
      nodes {
        id
        name
        section
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
      }
    }
  }
`;
